import { TableRow, TableCell, Typography } from '@mui/material';

// todo MATAN language, style file

type TalentsCounterProps = {
  total: number,
  tableColumnsCount: number,
};

const TalentsCounter = ({
  total,
  tableColumnsCount,
}: TalentsCounterProps):JSX.Element => {
  return (
    <TableRow>
      <TableCell
        colSpan={ tableColumnsCount }
        color="secondary"
        sx={
          {
            pt: '6px',
            pl: '20px',
            pb: '6px',
            color: 'text.secondary',
          }
        }
      >
        <Typography variant="overline" sx={ { color: '#6B7280' } }>  { total } Talents </Typography>
      </TableCell>
    </TableRow>
  );
};

export default TalentsCounter;
